import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {Http, Response, Headers, RequestOptions, ResponseContentType} from '@angular/http';
import {RunningDocument, Provider, RunningDocumentInfo, LastDates, DateInterval} from '../pages/gestion-park/model/index';
import 'rxjs/Rx' ;
import {GlobalService} from "./global.config";
import { User } from '../objects/real-time';
import {Events } from 'ionic-angular';

@Injectable()
export class DocumentCirculationService {
    currentuser:User;
    dns:string;
    constructor(private _http: Http,private globalService : GlobalService,public events: Events) {
        this.currentuser= JSON.parse(localStorage.getItem('currentuser'));
      this.dns = globalService.getDns();
       console.log(this.dns);

    }
    readData(idVehicule: number, type: string, fileName: string): Observable<RunningDocumentInfo[]> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'runningDocuments/readData/' + idVehicule + '?type=' + type + '&fileName=' + fileName,
            {
                headers: headers
            }
        ).map(res => res.json());
    }

    getListDocuments(idVehicule: number, type: string): Observable<RunningDocumentInfo[]> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'runningDocuments/listByType/' + idVehicule + '?type=' + type, {headers: headers}).map(res => res.json());
    }

    getProviders(type: string): Observable<Provider[]> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'providers/listByType?type=' + type, {headers: headers}).map(res => res.json());
    }

    getExpirationDates(idVehicule: number): Observable<LastDates> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'runningDocuments/expirationDates/' + idVehicule, {headers: headers}).map(res => res.json());
    }

    downloadFile(fileName: string): Observable<any> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'upload/files/' + fileName, {headers: headers}).map(res => res.json());
    }

    delete(idRunningDocument: number): Observable<Boolean> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.delete(this.dns + 'runningDocuments/' + idRunningDocument, {headers: headers}).map(res => res.json());
    }

    public getDataInExcel(idVehicule: number, type: string, date: DateInterval): Observable<Blob> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers, responseType: ResponseContentType.Blob});
        let body = JSON.stringify(date);
        return this._http.post(this.dns + 'runningDocuments/exportExcel/' + idVehicule + '?type=' + type, date, options).map(res => res.blob());
    }

    public add(documente: RunningDocument, idVehicule: number, idProvider: number, providerName: string): Observable<RunningDocumentInfo> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(documente);
        return this._http.post(this.dns + 'runningDocuments/?idVehicule=' + idVehicule + '&idProvider=' + idProvider + '&providerName=' + providerName, documente, options).map(res => res.json());
    }

    public update(documente: RunningDocument, idProvider: number, providerName: string): Observable<RunningDocumentInfo> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(documente);
        return this._http.put(this.dns + 'runningDocuments/?idProvider=' + idProvider + '&providerName=' + providerName, documente, options).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./src/providers/document-circulation.service.ts